import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propFunc, propStr } from '../../helpers/custom-prop-types';
const HelpFixedButton = (props) => {
    const { className, isLoading, onClick } = props;
    return (_jsx("button", Object.assign({ className: `help_button animated-opacity ${className}`, id: 'help_fixed_button', onClick: onClick, type: 'button' }, { children: isLoading ? (_jsxs("span", Object.assign({ className: 'help_button_dots' }, { children: [_jsx("span", {}), _jsx("span", {}), _jsx("span", {})] }))) : (_jsx("span", Object.assign({ className: 'help_button_text' }, { children: "\u30D8\u30EB\u30D7" }))) })));
};
HelpFixedButton.propTypes = {
    className: propStr().isRequired,
    isLoading: propBool().isRequired,
    onClick: propFunc().isRequired,
};
export default HelpFixedButton;
